<template>
    <div id="app">
        <router-view name="header"/>
        <div>
            <router-view/>
        </div>
        <router-view name="footer"/>
    </div>
</template>
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-48890822-13"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-48890822-13');
  export default {
  }
</script>
